import React from 'react'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

const Navbar = () => {

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={`flex justify-between lg:justify-around w-full bg-white items-center border-b sticky top-0 ${isScrolled ? 'h-[8vh] bg-opacity-80' : 'min-h-[10vh]'} ease-out duration-300 z-10`}>
      <a href="/" className='flex items-center ml-2 lg:ml-0'>
        <img src={`/images/logo.webp`} className={`pr-2 ${isScrolled ? 'w-10' : 'w-16'} ease-out duration-300`} alt="" />
        <h1 onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className={`sm:w-full font-extrabold text-[#0d1d31] hover:cursor-pointer ${isScrolled ? 'text-lg sm:text-2xl' : 'text-2xl sm:text-4xl'} ease-out duration-300`}>Fête Votive d'Ardèche</h1>
      </a>
      <Link
        to="/soumettre-votive"
        className={`my-2 mr-2 lg:mr-0 hover:bg-white text-center bg-green-600 border border-green-600 text-white hover:text-green-600 font-bold rounded duration-300 whitespace-nowrap ${isScrolled ? 'text-xs sm:text-sm py-1 px-2 sm:px-3' : 'text-sm sm:text-base py-2 px-3 sm:px-4'}`}
      >
        + Ajouter
      </Link>
    </div>
  )
}

export default Navbar